import { render, staticRenderFns } from "./GoodsFilter.vue?vue&type=template&id=56f1d38d&scoped=true"
import script from "./GoodsFilter.vue?vue&type=script&lang=js"
export * from "./GoodsFilter.vue?vue&type=script&lang=js"
import style0 from "./GoodsFilter.vue?vue&type=style&index=0&id=56f1d38d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1d38d",
  null
  
)

export default component.exports